<template>
  <BoxWithTitle
    class="my-4"
    :collapsible="true"
  >
    <template v-slot:header>
      <v-toolbar-title>
        {{ $t('profile.password') }}
      </v-toolbar-title>
    </template>
    <template v-slot:content>
      <ChangePasswordForm />
    </template>
  </BoxWithTitle>
</template>

<script>
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';
import ChangePasswordForm from '@/components/profile/ChangePasswordForm';

export default {
    components: {
        BoxWithTitle,
        ChangePasswordForm,
    },
};
</script>
